<template>
  <div :class="$style.container">
    <div :class="$style.tabs">
      <div :class="$style.scrollPane">
        <a
          v-for="(tab, index) in config.length"
          :key="`${index}-aKey`"
          :class="[
            $style.tab,
            activeTab === tab && $style.active,
            config[index].disabled && $style.disabled,
          ]"
          @click="updateTabs(tab)"
        >
          {{ config[index].title }}
        </a>
      </div>
    </div>
    <div
      v-for="(tab, index) in config.length"
      :key="`${index}-bKey`"
      :class="[$style.content, activeTab === tab && $style.activeContent]"
    >
      <div v-if="contentLoaded === false" class="preloadFilter"><Loading /></div>
      <div v-if="activeTab === tab && !config[index].withFilter" v-html="content" />
      <div v-if="activeTab === tab && config[index].withFilter">
        <BranchList :config="listConfig" />
      </div>
    </div>
  </div>
</template>

<script setup>
import BranchList from '../BranchList/BranchList.vue';
import Loading from '../Loading/Loading.vue';

import { onMounted, onUnmounted, ref, useCssModule } from 'vue';
import { checkIsMobile } from '../../utils/media';
import safeFetch from '../../utils/safeFetch';

const $style = useCssModule();

const props = defineProps({
  config: {
    type: Array,
    default: () => [],
  },
});

const isMobile = ref(false);
const activeTab = ref(null);
const mobileHidden = ref(null);
const content = ref(null);
const contentLoaded = ref(false);
const activeTabPreselected = ref(false);
const listConfig = ref('');

const checkScreenSize = () => (isMobile.value = checkIsMobile());

const updateTabs = (tab) => {
  const elm = event.currentTarget;
  if (!elm.classList.contains($style.disabled)) {
    contentLoaded.value = false;
    if (props.config[tab - 1].url) {
      getContentFromUrl(props.config[tab - 1].url);
      content.value = '';
    } else if (props.config[tab - 1].id) {
      getContentFromId(props.config[tab - 1].id);
    } else if (props.config[tab - 1].withFilter) {
      listConfig.value = props.config[tab - 1].listConfig;
      contentLoaded.value = true;
    } else {
      content.value = null;
    }
    if (isMobile.value && activeTab.value === tab && activeTab.value !== mobileHidden.value) {
      mobileHidden.value = tab;
    } else if (
      isMobile.value &&
      activeTab.value === tab &&
      activeTab.value === mobileHidden.value
    ) {
      mobileHidden.value = null;
    } else if (isMobile.value && activeTab.value !== tab) {
      mobileHidden.value = null;
      activeTab.value = tab;
    } else {
      activeTab.value = tab;
    }
  }
};

const getContentFromId = (id) => {
  const html = document.getElementById(id);
  if (html) {
    content.value = html.innerHTML;
    contentLoaded.value = true;
  } else {
    content.value = null;
    contentLoaded.value = false;
  }
};

const getContentFromUrl = (url) => {
  safeFetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((text) => ((content.value = text), (contentLoaded.value = true)))
    .catch((error) => (console.log(error), (content.value = null), (contentLoaded.value = false)));
};

onMounted(() => {
  setTimeout(() => {
    const modalFigures = document.querySelectorAll('.ContentTeaserS__container');
    modalFigures.forEach((figure) => {
      const videoLink = figure.querySelector('.ContentTeaserS__videoLink');
      const modal = figure.querySelector('.modal');
      const iframe = figure.querySelector('iframe');
      const consentBox = figure.querySelector('.Modal__consent');
      if (consentBox) {
        consentBox.remove();
      }
      if (videoLink && modal && iframe) {
        videoLink.addEventListener('click', (e) => {
          e.preventDefault();
          const dataSrc = iframe.getAttribute('data-src');
          const existingSrc = iframe.getAttribute('src');
          if (!existingSrc && dataSrc) {
            iframe.setAttribute('src', dataSrc);
          }
          modal.classList.add('is-active');
        });
      }
    });
    document.addEventListener('click', (e) => {
      if (
        e.target.matches('.modal-close') ||
        e.target.closest('.modal-close') ||
        e.target.matches('.modal-background')
      ) {
        const activeModal = document.querySelector('.modal.is-active');
        if (activeModal) {
          const iframe = activeModal.querySelector('iframe');
          if (iframe) {
            iframe.setAttribute('src', '');
          }
          activeModal.classList.remove('is-active');
        }
      }
    });
  }, 500);
  window.addEventListener('resize', checkScreenSize.value);
  checkScreenSize();
  const queries = window.location.search.substring(1).split('&');
  let queryStringTabId = null;
  if (queries) {
    for (const query of queries) {
      if (query.includes('tab')) {
        queryStringTabId = query.split('=')[1];
      }
    }
  }

  for (const [index, tab] of props.config.entries()) {
    if (
      (queryStringTabId && queryStringTabId == index + 1 && !tab.disabled) ||
      (tab.active && !tab.disabled)
    ) {
      activeTab.value = index + 1;
      activeTabPreselected.value = true;
      if (tab.url) {
        getContentFromUrl(tab.url);
      } else if (tab.id) {
        getContentFromId(tab.id);
      } else if (tab.withFilter) {
        listConfig.value = tab.listConfig;
        contentLoaded.value = true;
      }
    }
  }
  if (!activeTabPreselected.value) {
    activeTab.value = 1;
    if (props.config[0].url) {
      this.getContentFromUrl(props.config[0].url);
    } else if (props.config[0].id) {
      this.getContentFromId(props.config[0].id);
    } else if (props.config[0].withFilter) {
      listConfig.value = props.config[0].listConfig;
      contentLoaded.value = true;
    }
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize.value);
});
</script>

<style lang="css" module src="../ContentTabs/ContentTabs.scss" />
